import {
  avaliarConsultaDoNome,
  type ContextoDaConsulta,
  type DecisaoDeConsulta,
} from '../DadosConjuge/consultaNomeConjuge';

export type { ContextoDaConsulta, DecisaoDeConsulta };

export const avaliarConsultaDoNomeDoTitular = (
  contexto: ContextoDaConsulta,
  cpf?: string,
  data?: string,
): DecisaoDeConsulta => {
  if (!contexto.acessoAdministrativo || contexto.edicao || !contexto.consultarNome)
    return { consultar: false };

  return avaliarConsultaDoNome(
    { edicao: false, consultarNome: true, acessoAdministrativo: true },
    cpf,
    data,
  );
};

export const aposVerificarInscricao = (possuiInscricao: boolean, consultarNome: boolean) => ({
  permiteCadastro: !possuiInscricao && !consultarNome,
  consultarNome: false as const,
});
